// @component ./colors.tsx
import * as Colors from './colors';
export { Colors };

// @component ./DarkTheme.tsx
export { default as DarkTheme } from './DarkTheme';

// @component ./DefaultTheme.tsx
export { default as DefaultTheme } from './DefaultTheme';
